export { default } from './footer'
export type { Props as FooterProps } from './footer'
